/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React from "react";

//@Packages
import { t } from "i18next";
import { useDispatch } from "react-redux";
import { useOidc } from "@axa-fr/react-oidc";
import { useNavigate } from "react-router-dom";
import { Button, SignOutIcon } from "@forge/common";

//@Actions
import { setLogoutIntiated } from "../../actions";

//@Constants
import { LOCALE_CONST } from "../../utils/constants";

//@Styles
import "./styles.scss";

//@Functional Component

interface LogoutButtonProps {
  isModalButton?: boolean;
}

const LogoutButton = (
  {isModalButton = false}: LogoutButtonProps

) => {
  const { logout } = useOidc();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    navigate("/logout");
    dispatch(setLogoutIntiated({ logoutIntiated: true }));
    logout();
  };

  return (
    <>
      {isModalButton ? (
        <Button className="logout-btn-without-icon" variant="secondary" title={t(LOCALE_CONST.logout)} size="large" onClick={handleLogout}>
          {t(LOCALE_CONST.logout)}
        </Button>
      ) : <Button className="logout-btn-cls" variant="secondary" title={t(LOCALE_CONST.logout)} size="large" onClick={handleLogout}>
        <SignOutIcon className="signout-icon-cls" /> {t(LOCALE_CONST.logout)}
      </Button>}

    </>
  );
};

export default LogoutButton;